import { IconName } from '@fortawesome/free-solid-svg-icons';
import { AdminQueryUsage } from '../../../backend/src/api/dto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router"


function DisplayUsage({ data }: { data: AdminQueryUsage[] }) {

    return (

        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="text-center">Typ</th>
                    <th>Meno</th>
                    <th className="text-center">Odkaz</th>
                </tr>
            </thead>
            <tbody>
                {
                    data.map(usage => {
                        return (
                            <tr>
                                <td className="text-center"><FontAwesomeIcon fixedWidth icon={["fas", usage.type as IconName]} title={usage.type} /> </td>
                                <td>{usage.name}</td>
                                <td className="text-center">
                                    {
                                        usage.url ? <Link to={'/dashboard' + usage.url}><FontAwesomeIcon fixedWidth icon={["fas", "arrow-up-right-from-square"]} /></Link> : 'N/A'
                                    }
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )

}

export default DisplayUsage